/**
 * @description 时长设置器
 */
import React, { useEffect, useState } from 'react';
import Picker from '@umu/umu-picker';
import './timeSelect.scss';
import { localeConfig } from './localeConfig';
import { getDurationObj } from '../../@utils/umuUtil';
import timeDurationGenerateConfig, { TimeDuration } from '@umu/umu-picker/lib/generate/timeDuration';

export interface IProps {
    handlerConfirmSelect: (value: string) => void;
    initValue?: number;
    onChange: (newValue: any) => void;
    maxHour?: number;
    useSecond?: boolean;
}

const UMUPicker: any = Picker;

export function TimeSelect(props: IProps) {
    const [value, setValue] = useState<TimeDuration>();

    useEffect(() => {
        const initValue = props.initValue;
        if (initValue) {
            const { hours, seconds, minutes } = getDurationObj(initValue);

            setValue(
                new TimeDuration({
                    hour: Number(hours),
                    minute: Number(minutes),
                    second: Number(seconds),
                }),
            );
        }
    }, [props.initValue]);

    // const onSelect = (newValue: any, e: any) => {
    //     console.log(newValue, e)
    //     if (!props.handlerConfirmSelect) {
    //         return;
    //     }
    //     setValue(newValue);
    //     props.handlerConfirmSelect(newValue);
    // };
    const onChange = (newValue: TimeDuration) => {
        setValue(newValue);
        props.onChange(newValue.hour * 3600 + newValue.minute * 60 + newValue.second);
    };

    const sharedProps = {
        generateConfig: timeDurationGenerateConfig,
        value,
        onChange,
    };

    return (
        <UMUPicker
            {...props}
            {...sharedProps}
            locale={localeConfig.locale}
            picker="time"
            suffixIcon={<div className="time-select-icon" />}
            className="time-select"
            dropdownClassName="time-select-dropdown"
        />
    );
}
